import './Home.scss';
import React from 'react';
import Content from './Content';
import HomeChart from './HomeChart';
import DeviceService from '../../services/device-service';
import { Device } from '../interfaces';
import { TEHRAN_COORDINATES } from '../../utils/points';
import { Map, MarkerOption } from '../../utils/openlayer/map';

import markerRedImage from '../../assets/marker-red-30.png';
import markerBlueImage from '../../assets/marker-blue-30.png';

export default class Home extends React.Component {

  private deviceService = new DeviceService();
  private columnCount = 0;

  state = {
    prefs: {
      map: false,
      graph: false,
      alarm: false,
    },
    devices: [] as Device[]
  }

  render() {
    this.columnCount = 0;
    return (
      <Content title="خانه">
        <div className="home-component row">
          {this.renderChart()}
          {this.renderMap()}
        </div>
      </Content>
    );
  }

  renderChart = () => {
    const { graph } = this.state.prefs;
    if (!graph) return '';

    this.columnCount++;
    return (
      <div className={this.getColumnClasses()}>
        <HomeChart />
      </div>
    );
  }

  renderMap = () => {
    const { map } = this.state.prefs;
    if (!map) return '';

    this.columnCount++;
    return (
      <div className={this.getColumnClasses()}>
        <div id="home-map" className="ol-map"></div>
      </div>
    );
  }

  getColumnClasses = () => {
    if (this.columnCount === 1 || this.columnCount === 2) {
      return 'col-xxl-6 col-xl-12 col-12 mt-3';
    }
    return 'col-12 mt-3';
  }

  isColumnFilled = () => {
    return this.columnCount !== 1 && this.columnCount !== 2;
  }

  componentDidMount = async () => {
    const devices = await this.deviceService.fetch();
    await new Promise(resolve => this.setState({ devices }, resolve as any));
    if (this.state.prefs.map) {
      this.createMap();
    }
  }

  private createMap = () => {
    new Map({
      id: 'home-map',
      center: TEHRAN_COORDINATES,
      markers: this.provideMarkerFromDevices(),
      markerFitZoom: true,
      maxZoom: 17
    });
    document.querySelectorAll('.popup-btn').forEach(x => x.addEventListener('mouseup', this.handlePopupClick))
  }

  private provideMarkerFromDevices = () => {
    return this.state.devices
      .filter(s => s.location && s.location.lat && s.location.lng)
      .map(s => {
        return ({
          image: (s.alarm && s.alarm.status === 1) ? markerRedImage : markerBlueImage,
          point: [s.location?.lng, s.location?.lat],
          popup: `
            <div class="home-ul-popup">
              <div>${s._id}</div>
              <hr />
              <div class="marker-buttons">
                <span class="popup-btn ant-btn ant-btn-primary" data-href="/dashboard/graph/${s._id}">
                  <i class="far fa-chart-pie"></i>
                  مشاهده گراف
                </span>
                <span
                  class="popup-btn ant-btn ant-btn-primary"
                  data-href="/dashboard/devices/edit/${s._id}">
                  <i class="far fa-cog"></i>
                  تنظیمات
                </span>
              </div>
            </div>
          `
        }) as MarkerOption
      });
  }

  private handlePopupClick = (event: MouseEvent) => {
    const target = event.currentTarget as HTMLElement;
    const href = target.getAttribute('data-href');
    window.location.href = href;
  }

}
